var map = {
	"./views/b2b/b2b.module": [
		"./src/app/views/b2b/b2b.module.ts",
		"default~views-b2b-b2b-module~views-b2c-b2c-module~views-entegre-entegre-module~views-items-items-mod~bc5491e2",
		"default~views-b2b-b2b-module~views-b2c-b2c-module",
		"common",
		"views-b2b-b2b-module"
	],
	"./views/b2c/b2c.module": [
		"./src/app/views/b2c/b2c.module.ts",
		"default~views-b2b-b2b-module~views-b2c-b2c-module~views-entegre-entegre-module~views-items-items-mod~bc5491e2",
		"default~views-b2b-b2b-module~views-b2c-b2c-module",
		"common",
		"views-b2c-b2c-module"
	],
	"./views/dashboard/dashboard.module": [
		"./src/app/views/dashboard/dashboard.module.ts",
		"views-dashboard-dashboard-module"
	],
	"./views/entegre/entegre.module": [
		"./src/app/views/entegre/entegre.module.ts",
		"default~views-b2b-b2b-module~views-b2c-b2c-module~views-entegre-entegre-module~views-items-items-mod~bc5491e2",
		"common",
		"views-entegre-entegre-module"
	],
	"./views/items/items.module": [
		"./src/app/views/items/items.module.ts",
		"default~views-b2b-b2b-module~views-b2c-b2c-module~views-entegre-entegre-module~views-items-items-mod~bc5491e2",
		"common",
		"views-items-items-module"
	],
	"./views/manager/manager.module": [
		"./src/app/views/manager/manager.module.ts",
		"default~views-b2b-b2b-module~views-b2c-b2c-module~views-entegre-entegre-module~views-items-items-mod~bc5491e2",
		"common",
		"views-manager-manager-module"
	],
	"./views/pay/pay.module": [
		"./src/app/views/pay/pay.module.ts",
		"default~views-b2b-b2b-module~views-b2c-b2c-module~views-entegre-entegre-module~views-items-items-mod~bc5491e2",
		"common",
		"views-pay-pay-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;